import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import CButton from '@/components/shared/CButton';
import CCheckbox from '@/components/shared/CCheckbox.vue';
import type { BoundedTextElement } from '@/typings/customilyElements/canvasElements';
import type { CanvasEx } from '@/typings/canvas';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextPathProperties',
  props: {
    canvas: null,
    textElement: null
  },
  emits: ["element-props-updated"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'element-props-updated', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    canvas: CanvasEx;
    textElement?: BoundedTextElement;
};





// textElement is the same fabric object instance mutated in place by setTextPathPreset()/
//  toggleTextPathEditor() (this.textPath = ..., this.isEditingTextPath = ...) - Angular's
//  v-props-text-element watch only re-evaluates on reference changes, so a plain computed()
//  off props.textElement never notices those in-place mutations. Local refs, explicitly
//  re-synced right after every action, sidestep that instead of relying on prop reactivity.
const isEditing = ref(false);
const hasPath = ref(false);
const autoFit = ref(true);
const debugPath = ref(false);

const syncState = () => {
    isEditing.value = !!props.textElement?.isEditingTextPath;
    hasPath.value = !!props.textElement?.textPath;
    autoFit.value = props.textElement?.textPathAutoFit !== false;
    debugPath.value = !!props.textElement?.textPathDebug;
};

watch(() => props.textElement, syncState, { immediate: true });

const notify = () => {
    const element = props.textElement;
    if (!element) return;
    if (element.fire) {
        element.fire('modified');
    }
    props.canvas.requestRenderAll();
    syncState();
    emit('element-props-updated', element.uuid as string);
};

const applyPreset = (preset: 'straight' | 'line' | 'arc' | 'angle' | 'wave') => {
    const element = props.textElement;
    if (!element) return;
    element.setTextPathPreset(preset);
    notify();
};

const toggleEditor = () => {
    const element = props.textElement;
    if (!element) return;
    element.toggleTextPathEditor();
    notify();
};

const handleAutoFitChange = (value: boolean) => {
    const element = props.textElement;
    if (!element) return;
    element.setTextPathAutoFit(value);
    notify();
};

const handleDebugChange = (value: boolean) => {
    const element = props.textElement;
    if (!element) return;
    element.setTextPathDebug(value);
    notify();
};

return { __sfc: true,props, emit, isEditing, hasPath, autoFit, debugPath, syncState, notify, applyPreset, toggleEditor, handleAutoFitChange, handleDebugChange, CButton, CCheckbox }
}

})